import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShortText = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "1em",
	viewBox: "0 -960 960 960",
	width: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M200-360q-17 0-28.5-11.5T160-400q0-17 11.5-28.5T200-440h320q17 0 28.5 11.5T560-400q0 17-11.5 28.5T520-360H200Zm0-160q-17 0-28.5-11.5T160-560q0-17 11.5-28.5T200-600h560q17 0 28.5 11.5T800-560q0 17-11.5 28.5T760-520H200Z" })
});
export default SvgShortText;
